// Modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppModule as CareerPagesBaseModule } from '../';

// Components
import {
  CustomerSiteHeaderComponent,
  CustomerSiteIntroComponent,
  CustomerSiteFooterComponent,
  CustomerSiteColumnImageComponent,
  CustomerSiteColumnVideoComponent,
  CustomerSiteColumnTextComponent,
  CustomerSiteColumnCtaComponent,
  CustomerSiteColumnTestimonialComponent,
  CustomerLinksMenuComponent
} from '../../components';
import { RouterModule } from '@angular/router';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    CareerPagesBaseModule,
  ],
  declarations: [
    CustomerSiteHeaderComponent,
    CustomerSiteIntroComponent,
    CustomerSiteFooterComponent,
    CustomerSiteColumnImageComponent,
    CustomerSiteColumnVideoComponent,
    CustomerSiteColumnTextComponent,
    CustomerSiteColumnTestimonialComponent,
    CustomerLinksMenuComponent,
    CustomerSiteColumnCtaComponent,
  ],
  exports: [
    CustomerSiteHeaderComponent,
    CustomerSiteIntroComponent,
    CustomerSiteFooterComponent,
    CustomerSiteColumnImageComponent,
    CustomerSiteColumnVideoComponent,
    CustomerSiteColumnTextComponent,
    CustomerSiteColumnTestimonialComponent,
    RouterModule,
    CustomerLinksMenuComponent,
    CustomerSiteColumnCtaComponent,
  ]
})
export class CustomerSiteModule {}